import { z } from 'zod';

export const LocationRequestSchema = z.object({
    // customer_id: z.number().nullable().catch(null),
    ext_id: z.string(),
    address_id: z.coerce.number().nullable().catch(null),
    full_name: z.string(),
    is_ad_hoc: z.boolean().catch(false),
    coords_accepted: z.boolean().catch(false).describe('not implemented in DB'),
    location_type: z.string().catch(''),
    geom: z
        .object({
            type: z.literal('Point'),
            coordinates: z.array(z.number()).length(2),
        })
        .nullable()
        .catch(null),
    // webuser_id: z.number().nullable().catch(null),
    // collection_id: z.number().nullable().catch(null),
    // job_type_id: z.number().catch(1), // SELECT * FROM public.job_type; 1=single 2=schedule
    // import_id: z.number().nullable().catch(null),
    address_attributes: z
        .object({
            city: z.string().nullable().catch(null),
            house: z.string().nullable().catch(null),
            pcode: z.string().nullable().catch(null),
            street: z.string().nullable().catch(null),
            country: z.string().nullable().catch(null),
            quarter: z.string().nullable().catch(null),
            province: z.string().nullable().catch(null),
            community: z.string().nullable().catch(null),
        })
        .nullable()
        .catch(null),
    special_attributes: z.record(z.string()).nullable().catch(null),
    client_attributes: z.record(z.string()).nullable().catch(null),
});
export type LocationRequestType = z.infer<typeof LocationRequestSchema>;

export const LocationResponseSchema = LocationRequestSchema.merge(
    z.object({
        id: z.number(),
    })
);
export type LocationResponseType = z.infer<typeof LocationResponseSchema>;

export const JobCountSchema = z.object({
    count: z.coerce.number().catch(0),
});
export type JobCountType = z.infer<typeof JobCountSchema>;
